/** 시스템 관리 → 알림 탭: 채널별 설정 카드 블록 스타일 */

import type { SxProps, Theme } from '@mui/material';

export const SAFETY_ALERT_BLOCK = {
  sms: {
    key: 'sms' as const,
    titleAccent: 'primary.main',
    label: '현장 안전 SMS',
  },
  kakao: {
    key: 'kakao' as const,
    titleAccent: '#3C1E1E',
    label: '카카오 알림톡',
  },
  wearable: {
    key: 'wearable' as const,
    titleAccent: 'info.main',
    label: '웨어러블 알림',
  },
};

export function safetyAlertSettingsCardSx(
  channel: keyof typeof SAFETY_ALERT_BLOCK
): SxProps<Theme> {
  const accent = SAFETY_ALERT_BLOCK[channel].titleAccent;
  return {
    mb: 2,
    borderLeft: 4,
    borderColor: accent,
    boxShadow: 2,
  };
}
